/**
 * Semantic linter rule for MultiplayerSynchronizer, from Godot's configuration warning on
 * `root_path.is_empty() || !has_node(root_path)` (multiplayer_synchronizer.cpp:146-154). The default
 * `NodePath("..")` (doc/classes/MultiplayerSynchronizer.xml) resolves or is `unknowable`, never
 * `missing`, so only a present path naming no node warns. Not an error: the scene loads (ADR-0032).
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { extractNodePath } from '../../../linter/linterUtils.js';
import { resolveNodePath } from '../../../linter/nodePathResolve.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
const arms = {
    rootPathDangling: groundedArm('multiplayersynchronizer-root-path-dangling', {
        kind: 'configuration-warning',
    }),
};
function checkMultiplayerSynchronizer(context) {
    const { node, scene } = context;
    const raw = node.rawProperties.root_path;
    if (!raw)
        return [];
    const path = extractNodePath(raw);
    if (!path)
        return [];
    const target = resolveNodePath(scene, node, path);
    if (target.status !== 'missing')
        return [];
    return [
        armDiagnostic(arms.rootPathDangling, node, `MultiplayerSynchronizer '${node.name}' has root_path set to NodePath("${path}"), which names no node in this file. A valid Root Path is required for MultiplayerSynchronizer to synchronize properties.`),
    ];
}
const multiplayerSynchronizerRootPathRule = {
    meta: {
        name: 'valid-multiplayersynchronizer-root-path',
        description: "Warns when MultiplayerSynchronizer's root_path names no node in this file, mirroring Godot's own configuration warning",
        category: 'validation',
        applicableNodeTypes: ['MultiplayerSynchronizer'],
        emits: armEmits(arms),
    },
    check: checkMultiplayerSynchronizer,
};
ruleRegistry.register(multiplayerSynchronizerRootPathRule);
//# sourceMappingURL=linter.js.map